goog.provide('yext.ajax');

goog.require('yext.dialog');

/**
 * Ajax error wrapper.
 *
 * @param {Function} f
 * @param {Object=} opt_progressTimeoutId
 * @return {!function(?, ?): ?}
 */
yext.ajax.errorWrapper = function(f, opt_progressTimeoutId) {
  return function(jqXHR, textStatus) {
    // Ignore if request was aborted by the user (ESC or change page)
    // http://ilikestuffblog.com/2009/11/30/how-to-distinguish-a-user-aborted-ajax-call-from-an-error/
    // or if storm aborted a request to start a new one
    // (e.g. this.loadTableQuery.abort(); in datatable.js)
    if (!jqXHR.getAllResponseHeaders() || textStatus === 'abort') {
      if (opt_progressTimeoutId) {
        yext.dialog.hideDelayedProgressDialog(opt_progressTimeoutId);
      }
      return;
    }
    return f.apply(this, arguments);
  };
};
goog.exportSymbol('ajaxErrorWrapper', yext.ajax.errorWrapper);
